import { render } from "./ComponentNextStep.vue?vue&type=template&id=063800c8&scoped=true"
import script from "./ComponentNextStep.vue?vue&type=script&lang=js"
export * from "./ComponentNextStep.vue?vue&type=script&lang=js"

import "./ComponentNextStep.vue?vue&type=style&index=0&id=063800c8&scoped=true&lang=css"
import "./ComponentNextStep.vue?vue&type=style&index=1&id=063800c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063800c8"]])

export default __exports__